import {Component, Inject, PLATFORM_ID} from "@angular/core";
import { Router} from "@angular/router";
import {roomDetails, ZIP_CODE_REG_EX} from "../../../shared/utils/utils";

import {PackageInterface, packageNameType} from "../../../shared/interfaces/package.interface";
import {environment} from "../../../../environments/environment";
import {FormControl, FormGroup, FormGroupDirective, Validators} from "@angular/forms";
import {DOCUMENT, isPlatformBrowser} from "@angular/common";
import {MoreInfoInterface} from "../../../shared/interfaces/room-type.interface";
import {Meta, Title} from "@angular/platform-browser";
import {PackageInformationInterface} from "../../../shared/interfaces/package-information.interface";
import {PageUrlService} from "../../../core/services/pageUrl.service";
import {BreakpointObserver, Breakpoints} from "@angular/cdk/layout";

@Component({
  selector: "sw-package-details",
  templateUrl: "./zs-package-details.component.html",
})
export class ZsPackageDetailsComponent {
  zipCodeForm: FormGroup = new FormGroup({
    zipCode: new FormControl<string>("", [Validators.required, Validators.pattern(ZIP_CODE_REG_EX)])
  });
  package?: PackageInformationInterface = {
    packageName: "Zwangerschap Schoonmaak",
    packageId: "zs",
    bulletPoints: [
      "Wil je een hygiënisch en allergenenvrij thuis voor jou en je baby?",
      "Zoek je naar rust en comfort in de laatste weken voor de geboorte?",
      "Wil je verzekerd zijn van een proper en veilig huis bij thuiskomst met je pasgeboren kindje?"
    ],
    description:
      "Maak je klaar voor de komst van je kleintje met onze speciale zwangerschapsschoonmaak. We zorgen ervoor dat je huis sprankelend schoon is, zodat je vol vertrouwen en in alle rust kunt genieten van de bijzondere tijd ",
    // imageUrl: "https://firebasestorage.googleapis.com/v0/b/dev-sw-nl.appspot.com/o/consumerApp%2Fzs.jpeg?alt=media&token=07401ed8-501f-4174-820a-cde5b0e8ea18"
  };
  details?: MoreInfoInterface;
  id: PackageInterface["packageId"] = "zs";
  isSmallScreen= false;

  constructor(private title: Title,
              private meta: Meta,
              private router: Router,
              private pageUrlService: PageUrlService,
              private breakpointObserver: BreakpointObserver,
              @Inject(PLATFORM_ID) private platformId: Object,
              @Inject(DOCUMENT) private document: Document) {
    this.loadData();
  }

  private loadData(): void {
    const pcg = this.router.url.split("?")[0].replace("/schoonmaakdiensten/", "") as packageNameType;
    if (pcg) {
      this.details = roomDetails.find(rd => rd?.packageId === this.id);
      this.getTags();
    }
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.breakpointObserver.observe([
        Breakpoints.Handset,
        '(max-width: 640px)'
      ]).subscribe(result => {
        this.isSmallScreen = result.matches;
      });
    }
  }

  onStart(form: FormGroupDirective): void {
    const zipCode = form.value?.zipCode;

    if (form.valid && isPlatformBrowser(this.platformId)) {
      const url = `${environment.redirectUrl}location?packageId=${this.id}&zipCode=${zipCode}`;
      this.document.location.href = url;
    }
  }

  onOpenLink(id = this.id): void {
    if (isPlatformBrowser(this.platformId)) {
      const url = `${environment.redirectUrl}location?packageId=${id}`;
      this.document.location.href = url;
    }
  }

  onSelect() {
    if (isPlatformBrowser(this.platformId)) {
      const url = `${environment.redirectUrl}location?packageId=ms}`;
      this.document.location.href = url;
    }
  }

  getTags(): void {
    const pageUrl = this.pageUrlService.getPageUrl();
    const pcg = this.package?.packageName?.toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    const title = `Schoonmaakwoede | ${pcg}`;
    this.title.setTitle(title);
    const tags = [
      {
        name: "title",
        content: title
      },
      {
        name: "keywords",
        content:  "Zwangerschaps schoonmaak, Zwangerschaps schoonmaak huis, Zwangerschaps schoonmaak woning, particulier poetsbedrijf, grondige schoonmaak,voorjaarsschoonmaak,voorjaar schoonmaak,lente schoonmaak,diep reinigen woonhuis,huis schoonmaken,huis schoonmaak"
      },
      {
        name: "canonical",
        content: pageUrl
      },
      {
        name: "description",
        content:  "Schoonmaakwoede is specialist in de Zwangerschaps schoonmaak. Met onze getrainde schoonmaak teams maken wij je huis goed & efficiënt schoon. Bestel direct je Zwangerschaps schoonmaak!"
      },
      {
        name: "og:title",
        content: title
      },
      {
        name: "og:description",
        content:  "Schoonmaakwoede is specialist in de Zwangerschaps schoonmaak. Met onze getrainde schoonmaak teams maken wij je huis goed & efficiënt schoon. Bestel direct je Zwangerschaps schoonmaak!" // Todo Desc

      },
      {
        name: "og:url",
        content: pageUrl
      },
      {
        name: "og:image",
        content: `${environment.baseUrl}/assets/logo.png` // ToDo Image we inject
      },
      {
        name: "robots",
        content: "index, follow"
      },
      {
        name: "viewport",
        content: "width=device-width, initial-scale=1.0"
      },
      {
        charset: "UTF-8"
      },
    ];
    tags.forEach((tag: any) => this.meta.updateTag(tag));
  }
}
